import { Alert, Button, DatePicker, Form, Input } from "antd";
import "antd/dist/antd.css";
import { isEmpty, toNumber } from "lodash";
import moment, { Moment } from "moment";
import React, { useEffect, useRef, useState } from "react";
import Geocode from "react-geocode";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import LeftSideNav from "../../components/LeftSideNav";
import { DATE_FORMAT1, DATE_FORMAT2 } from "../../constants/stringConstants";
import "../../css/users.css";
import { isEmailValid } from "../../functions/commons";
import { useSignupUserMutation } from "../../store/appSlice";
import { useAppDispatch } from "../../store/store";
import styles from "./styles";

function SignUp() {
  const [input, setInput] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    password: "",
  });

  const [error, setError] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    password: "",
  });

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [signupUser] = useSignupUserMutation();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);
  const [defaultCountry, setDefaultCountry] = useState<string>("us");
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [verified, setVerified] = useState<boolean>(false);

  useEffect(() => {
    Geocode.setApiKey("AIzaSyAnAXwnT1GTlRVUnEeApK09pTByQD4mdXU");

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude.toString();
        const longitude = position.coords.longitude.toString();

        Geocode.fromLatLng(latitude, longitude).then(
          (response: any) => {
            const country = response.results[0].address_components
              .find((component: any) => component.types.includes("country"))
              .short_name.toLowerCase();
            setDefaultCountry(country);
          },

          (error: any) => {
            console.error(error);
          }
        );
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  useEffect(() => {
    if (!isEmpty(errorMessage)) {
      setTimeout(() => {
        setErrorMessage("");
      }, 2000);
    }
  }, [errorMessage]);

  const validation = () => {
    const { name, email, phoneNumber, dateOfBirth, password } = input;

    let valid = true;
    let nameError = "";
    let dateOfBirthError = "";
    let emailError = "";
    let phoneError = "";
    let passwordError = "";

    if (isEmpty(password)) {
      valid = false;
      passwordError = "Password cannot be empty";
    }

    if (isEmpty(phoneNumber)) {
      valid = false;
      phoneError = "Number cannot be empty";
    }

    if (isEmpty(email)) {
      valid = false;
      emailError = "Email cannot be empty";

      valid = false;
    } else if (!isEmailValid(email)) {
      valid = false;
      emailError = "Email is invalid";
    }

    if (isEmpty(dateOfBirth)) {
      valid = false;
      dateOfBirthError = "Date of birth cannot be empty";
    }

    if (isEmpty(name)) {
      valid = false;
      nameError = "Name cannot be empty";
    }
    console.log({ passwordError });

    setError({
      ...error,
      name: nameError,
      email: emailError,
      phoneNumber: phoneError,
      dateOfBirth: dateOfBirthError,
      password: passwordError,
    });

    return valid;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput({ ...input, [event.target.id]: event.target.value });
  };

  const handleMobileNumberChange = (event: String) => {
    setInput({ ...input, phoneNumber: `+${event}` });
    console.log("mobile number: ", `+${event}`);
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    if (validation()) {
      // if (true) {
      setLoading(true);
      let phone = input.phoneNumber.slice(1);
      console.log({ phone });
      const payload = {
        name: input.name,
        email: input.email,
        phoneNumber: toNumber(phone),
        password: input.password,
        dateOfBirth: moment(input.dateOfBirth).format(DATE_FORMAT1),
      };
      console.log({ payload });

      signupUser(payload)
        .unwrap()
        .then((payload: any) => {
          setLoading(false);
          navigate("/auth/verify_user");
        })
        .catch((err: any) => {
          setLoading(false);
          setErrorMessage(err?.data?.error?.message ?? "Something went wrong");
        });
    }
  };

  const handleChangeDate = (date: Moment | null) => {
    setInput({ ...input, dateOfBirth: `${date}` });
  };

  const errorSec = (err: string) => (
    <div style={{ marginTop: "-20px", marginBottom: "20px" }}>
      <text style={{ color: "red" }}>{err}</text>
    </div>
  );

  const asterikSign = () => (
    <h2 style={{ color: "red", fontSize: "20px", marginLeft: "10px" }}> *</h2>
  );

  const { name, email, phoneNumber, password } = input;

  const inputFormView = () => (
    <div className="main-right-div">
      <div className="right-header-div">
        <h4>Already have an account?</h4>

        <Button
          onClick={() => {
            navigate("/auth/login");
          }}
        >
          Sign In
        </Button>
      </div>
      <div className="signup-form-div">
        <h2 className="first_h1_signup_form-div">Create an account</h2>
        {!isEmpty(errorMessage) && (
          <Alert closable message={errorMessage} type="error" />
        )}
        <Form onFinish={handleSubmit}>
          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>Name </h2>
            {asterikSign()}
          </div>
          <Form.Item
            name="fullname"
            // hasFeedback
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Input
                status={`${isEmpty(error.name) ? "" : "error"}`}
                type="text"
                id="name"
                value={name}
                onChange={handleChange}
              />
            </div>
          </Form.Item>
          {!isEmpty(error.name) && errorSec(error.name)}

          <div className="sign-in__pswrd-frgt-pswrd">
            <h2> Date of Birth</h2>
            {asterikSign()}
          </div>
          <Form.Item
            name="dateofBirth"
            // hasFeedback
          >
            <DatePicker
              status={`${isEmpty(error.dateOfBirth) ? "" : "error"}`}
              style={{ width: "100%", borderRadius: 10, padding: "10px" }}
              dropdownClassName="fr-intrvw__dt-clndr"
              disabledDate={(current) => {
                let customDate = moment().format("YYYY-MM-DD");
                return current && current > moment(customDate, "YYYY-MM-DD");
              }}
              // defaultValue={moment(interviewDateTime.interviewDate, dateFormat)}
              value={moment(input.dateOfBirth, DATE_FORMAT2)}
              format={DATE_FORMAT2}
              onChange={(date: Moment | null, stringDate) => {
                handleChangeDate(date);
              }}
              allowClear={false}
            />
          </Form.Item>
          {!isEmpty(error.dateOfBirth) && errorSec(error.dateOfBirth)}

          <div className="sign-in__pswrd-frgt-pswrd">
            <h2> Email</h2>
            {asterikSign()}
          </div>
          <Form.Item
            name="email"
            // hasFeedback
          >
            <Input
              status={`${isEmpty(error.email) ? "" : "error"}`}
              type="text"
              id="email"
              value={email}
              onChange={handleChange}
              placeholder="abc@mail.com"
            />
          </Form.Item>
          {!isEmpty(error.email) && errorSec(error.email)}

          <div className="sign-in__pswrd-frgt-pswrd">
            <h2> Phone Number</h2>
            {asterikSign()}
          </div>
          <Form.Item
            name="phoneNumber"
            // hasFeedback
          >
            <PhoneInput
              country={defaultCountry}
              autoFormat={true}
              buttonStyle={{ borderWidth: 0, borderRadius: "7px" }}
              containerStyle={
                !isEmpty(error.phoneNumber)
                  ? { ...styles.phoneContainer, border: "2px solid red" }
                  : styles.phoneContainer
              }
              inputStyle={{ borderWidth: 0 }}
              dropdownStyle={{
                width: "451px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                alignContent: "flex-start",
                justifySelf: "flex-start",
                background: "white",
                zIndex: 100,
              }}
              searchStyle={{
                width: "410px",
              }}
              disableSearchIcon={true}
              enableSearch={true}
              placeholder="Enter phone number"
              value={phoneNumber}
              onChange={handleMobileNumberChange}
            />
          </Form.Item>
          {!isEmpty(error.phoneNumber) && errorSec(error.phoneNumber)}

          <div className="sign-in__pswrd-frgt-pswrd">
            <h2> Password</h2>
            {asterikSign()}
          </div>
          <Form.Item
            name="password"
            // hasFeedback
          >
            <Input.Password
              type="password"
              value={password}
              id="password"
              onChange={handleChange}
              className="input_password_style"
              style={!isEmpty(error.password) ? { borderColor: "red" } : {}}
            />
          </Form.Item>
          {!isEmpty(error.password) && errorSec(error.password)}

          <ReCAPTCHA
            ref={recaptchaRef}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
            }}
            // sitekey="6Lf9bR8nAAAAABlnMXqFv1Y_rqPPLUTRpASCWXh_" //staging
            sitekey="6Ld4DhAnAAAAAL8GnDgf2efNiuV6KGkSCfl067v_" //prod
            onChange={() => setVerified(true)}
          />

          <Form.Item>
            <div style={{ opacity: verified ? 1 : 0.5 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                disabled={isLoading || !verified}
              >
                Continue
              </Button>
            </div>
          </Form.Item>
        </Form>
        <p>
          By signing up, I agree to 01HIRE{" "}
          <a
            href="https://01hire.com/terms-conditions/"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="https://01hire.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  );

  return (
    <div className="login_container">
      <div className="left-nav-col">
        <LeftSideNav />
      </div>
      <div className="inputform_container">{inputFormView()}</div>
    </div>
  );
}

export default SignUp;
